import { render } from "./RecognizeByBest.vue?vue&type=template&id=7e46c922&scoped=true"
import script from "./RecognizeByBest.vue?vue&type=script&lang=js"
export * from "./RecognizeByBest.vue?vue&type=script&lang=js"

import "./RecognizeByBest.vue?vue&type=style&index=0&id=7e46c922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e46c922"]])

export default __exports__